export interface TokenResponse {
    accessToken: string;
}

export interface ShortLinkValidationResponse {
    success: boolean;
    maskedEmail?: string;
    maskedPhone?: string;
    errorMessage?: string;
}

export enum PageType {
    AddNewCreditCard = 'AddNewCreditCard',
    BookQuote = 'BookQuote',
    BookOrder = 'BookOrder',
    ChangeOrder = 'ChangeOrder',
    Dispatch = 'Dispatch',
    BillOfLadingUpload = 'BillOfLadingUpload'
}
